/*!
 * JavaScript Cookie v2.2.1
 * https://github.com/js-cookie/js-cookie
 *
 * Copyright 2006, 2015 Klaus Hartl & Fagner Brack
 * Released under the MIT license
 */
(function(c){if("function"===typeof define&&define.amd){define(c);var f=!0}"object"===typeof exports&&(module.exports=c(),f=!0);if(!f){var e=window.Cookies,a=window.Cookies=c();a.noConflict=function(){window.Cookies=e;return a}}})(function(){function c(){for(var e=0,a={};e<arguments.length;e++){var c=arguments[e],g;for(g in c)a[g]=c[g]}return a}function f(e){function a(){}function n(k,d,b){if("undefined"!==typeof document){b=c({path:"/"},a.defaults,b);"number"===typeof b.expires&&(b.expires=new Date(1*
new Date+864E5*b.expires));b.expires=b.expires?b.expires.toUTCString():"";try{var l=JSON.stringify(d);/^[\{\[]/.test(l)&&(d=l)}catch(q){}d=e.write?e.write(d,k):encodeURIComponent(String(d)).replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g,decodeURIComponent);k=encodeURIComponent(String(k)).replace(/%(23|24|26|2B|5E|60|7C)/g,decodeURIComponent).replace(/[\(\)]/g,escape);l="";for(var m in b)b[m]&&(l+="; "+m,!0!==b[m]&&(l+="="+b[m].split(";")[0]));return document.cookie=k+"="+d+l}}
function g(a,d){if("undefined"!==typeof document){for(var b={},k=document.cookie?document.cookie.split("; "):[],c=0;c<k.length;c++){var g=k[c].split("="),h=g.slice(1).join("=");d||'"'!==h.charAt(0)||(h=h.slice(1,-1));try{var f=g[0].replace(/(%[0-9A-Z]{2})+/g,decodeURIComponent);h=(e.read||e)(h,f)||h.replace(/(%[0-9A-Z]{2})+/g,decodeURIComponent);if(d)try{h=JSON.parse(h)}catch(p){}b[f]=h;if(a===f)break}catch(p){}}return a?b[a]:b}}a.set=n;a.get=function(a){return g(a,!1)};a.getJSON=function(a){return g(a,
!0)};a.remove=function(a,d){n(a,"",c(d,{expires:-1}))};a.defaults={};a.withConverter=f;return a}return f(function(){})});






jQuery(document).ready(function($) {

// $('#shopify-section-shop-dropdown').appendTo('.link-is-shop ');
let mql = window.matchMedia('(min-width: 768px)');
if ($(window).width() > 768 || mql.matches) {
	$('.link-is-shop .site-nav__link').append('<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon--wide icon-chevron-down" viewBox="0 0 498.98 284.49"><defs><style>.cls-1{fill:#231f20}</style></defs><path class="cls-1" d="M80.93 271.76A35 35 0 0 1 140.68 247l189.74 189.75L520.16 247a35 35 0 1 1 49.5 49.5L355.17 511a35 35 0 0 1-49.5 0L91.18 296.5a34.89 34.89 0 0 1-10.25-24.74z" transform="translate(-80.93 -236.76)"></path></svg>');
	$('.link-is-shop').click(function(event) {
		/* Act on the event */
		event.preventDefault();
		console.log("shop")
		$('.shopdropdown').toggleClass('is-active');

	});
}


// LOAD MORE BLOG POST

		 load_more = $(".blogPostGroup div.is-card-group_post-item").size();
		  x=4;
			 if (load_more <= 4 ){
				 $('.load-more-post').hide();
			 }

		     $('.blogPostGroup div.is-card-group_post-item:lt('+x+')').show();
		     $('#loadmorepost').click(function (event) {
				 event.preventDefault();
		         x= (x+4 <= load_more) ? x+4 : load_more;
		         $('.is-card-group_post-item:lt('+x+')').fadeIn(1800);
		         if(x >= load_more){
		         	$(this).hide();
		         }
		     });


		 // BLOG SLIDER

		 $(function() {
		     $('*[draggable!=true]','.slick-track').unbind('dragstart');
		   });

		 $('.blogSlick').slick({
		 	 slidesToShow: 3,
		 	 dots: false,
		 	 draggable: false,
		 	 responsive: [{
		 	 		  	breakpoint: 767,
		 	 	     	settings: {
		 	 	       slidesToShow: 1,
		 	 	       dots: false
		 	 	     }
		 	 }]
		 });


		 // INPUT COUNTERS
		 $('.is-product-qty-direction').click(function(event) {
		 	event.preventDefault();
		 	direction = $(this).data('direction');

		 	 inputqtybox = $('.is-product-qty-input');

		 	 var value = parseInt(inputqtybox.val(), 10);

	 	switch (direction) {
		 		case "increase":
		 			value = isNaN(value) ? 0 : value;
		 			value++;
		 			inputqtybox.val(value);
		 			break;
		 			case "decrease":
		 					var value = parseInt(inputqtybox.val(), 10);
		 				  value = isNaN(value) ? 0 : value;
		 				  value < 1 ? value = 1 : '';
		 				  value--;
		 				  inputqtybox.val(value);
		 				break;

		 	}
		 });



		 // WHY WE LOVE INGREDIENTS DESCRIPTION

		 $('.is-prod-desc-list li').click(function(event) {
		 		event.preventDefault();
		 		$(this).parent().find('li.selected').removeClass('selected');
		 		$(this).addClass('selected');
		 		var dtabs =  $(this).attr('data-tabs');
		 		console.log(dtabs)

		 		var boxclass = $('.has-prod-info-text .is-prod-info-text');
		 		boxclass.each(function(index, el) {
		 			boxid = $(this).attr('data-tabs');
		 			if (boxid == dtabs ) {
		 				$(this).addClass('selected')
		 			}
		 			else {
		 				$(this).removeClass('selected')
		 			}
		 		});

		 });



		 if ($(".home-hero_items").length > 0) {
		 // HOME HERO
		 	$(".home-hero_items").slick({
		 		slide: '.home-hero_item',
		 		arrows: false,
		 		dots: true,
		 		appendDots : $(".home-hero-dots"),
		 		slidesToShow: 1,
		   	slidesToScroll: 1,
		   	autoplay: true,
		   	autoplaySpeed: 8000,
		   	infinite: true

		   	// responsive: [{
		   	// 	breakpoint: 767,
		   	// 	settings: {
		   	// 		autoplay: false,
		   	// 		swipe : false,
		   	// 		draggable: false
		   	// 	}
		   	// }]
		 	});
		 	}


		 	if ($('.home-best-sellers-products').length > 0) {
		 		$('.home-best-sellers-products').slick({
		 			arrows: true,
		 			dots: false,
		 			slidesToShow: 4,
		 	  	slidesToScroll: 1,
		 	  	infinite: false,
		 	  	prevArrow : '<button type="button" class="slick-prev"><span class="icomoon-chevron-left"></span></button>',
		 	  	nextArrow : '<button type="button" class="slick-next"><span class="icomoon-chevron-right"></span></button>',
		 	  	responsive: [
		 		    {
		 		      breakpoint: 1024,
		 		      settings: {
		 		        slidesToShow: 3,
		 		        slidesToScroll: 3
		 		      }
		 		    },
		 		    {
		 		      breakpoint: 980,
		 		      settings: {
		 		        slidesToShow: 2,
		 		        slidesToScroll: 2
		 		      }
		 		    },
		 		    {
		 		      breakpoint: 600,
		 		      settings: {
		 		        slidesToShow: 1,
		 		        slidesToScroll: 1
		 		      }
		 		    }
		 	    ]
		 		});
		 	}

		if ($('.home-want-to-items').length > 0) {
		$('.home-want-to-items').slick({
		arrows: true,
		dots: false,
		slidesToShow: 3,
  	slidesToScroll: 1,
  	prevArrow : '<button type="button" class="slick-prev"><span class="icomoon-chevron-left"></span></button>',
  	nextArrow : '<button type="button" class="slick-next"><span class="icomoon-chevron-right"></span></button>',
  	responsive: [
	    {
	      breakpoint: 1024,
	      settings: {
	        slidesToShow: 2,
	        slidesToScroll: 2
	      }
	    },
	    {
	      breakpoint: 600,
	      settings: {
	        slidesToShow: 1,
	        slidesToScroll: 1
	      }
	    }
    ]
	});
	}

	if ($('.home-whats-new-items').length > 0) {


					        $('.home-whats-new-items').slick({
					        	arrows: true,
					        	infinite: false,
					        	dots: false,
					        	slidesToShow: 3,
					        	slidesToScroll: 1,
					        	prevArrow : '<button type="button" class="slick-prev"><span class="icomoon-chevron-left"></span></button>',
					        	nextArrow : '<button type="button" class="slick-next"><span class="icomoon-chevron-right"></span></button>',
					        	responsive: [
					        		{
					        				 breakpoint: 980,
					        				 settings: {
					        				   slidesToShow: 1,
					        				   slidesToScroll: 1
					        				 }
					        		}
					        	]
					        });


	}



	// TOGGLE FILTER SIDEBAR
	 $('.filterlist span').each(function() {
	    var $dropdown = $(this);

	    $($dropdown).click(function(e) {
	      e.preventDefault();
	      $div = $(".filtersub");
	      $('.filterlist span').removeClass('filter-active');

	      if ( $(this).next($div).is(':visible')) {
	      		$(this).removeClass('filter-active');
	      }else {
	      	$(this).addClass('filter-active');
	      }

	      $div.slideToggle('fast',function() {});
	      $(".filtersub").not($(this).next($div)).hide();


	      // SET cookie to keep open
	      var filtercookiedata = $(this).attr('data-filter-choice');
	      var filtercookie = Cookies.set('filter-cookie', filtercookiedata);
	      return false;
	    });

	    // GET COOKIES TO KEEP OPEN
	    var getfieldchoice = Cookies.get('filter-cookie');
	    var getspanfilter = $dropdown.attr('data-filter-choice');

	    if ($(window).width() > 980) {
			    	if (  getspanfilter == getfieldchoice   ) {
			    			$(this).addClass('filter-active');
			    			$(this).next('.filtersub').slideToggle('fast');
			    	 }
	    	 }

	});

	  $('html').click(function(){
	    $(".filtersub").hide();
	  });



// wait a bit for related to load
		$('.are-prod-related').delay(800).fadeIn(800);




// REFER A FRIEND MC

$('#referafriend .btn').click(function(event)	{
	event.preventDefault();
	$('.mcErrors p').remove();
	var $form = $('#referafriend');
	register($form);

	function register($form) {
			  $.ajax({
			    type: 'get',
			    url: 'https://skinstoreps.us4.list-manage.com/subscribe/post-json?u=844bd2ea54bccca150801b828&amp;id=0ca8ea6c51&c=?',
			    data: $form.serialize(),
			    cache: false,
			    dataType: 'json',
			    contentType: 'application/json; charset=utf-8',
			    error: function (err) { alert('Could not connect to the registration server. Please try again later.') },
			    success: function (data) {
			      if (data.result === 'success') {
			        // Yeahhhh Success
			        console.log(data.msg)
			        $('<p class="subscribedMC">Subscribed</p>').insertBefore('#referafriend');
			        $('#referafriend').hide();
			      } else {
			        // Something went wrong, do something to notify the user.
			        console.log(data.msg)
			        $('<p>'+data.msg+'</p>').appendTo('.mcErrors');
			      }
			    },
			    complete: function(){
			    }
			  });
			};
});

// MAILCHIMP POPUP
$('#referafriendpop .btn').click(function(event)	{
	event.preventDefault();
	$('.referpop .mcErrors p').remove();
	var $form = $('#referafriendpop');
	register($form);

	function register($form) {
			  $.ajax({
			    type: 'get',
			    url: 'https://skinstoreps.us4.list-manage.com/subscribe/post?u=844bd2ea54bccca150801b828&amp;id=0ca8ea6c51&c=?',
			    data: $form.serialize(),
			    cache: false,
			    dataType: 'json',
			    contentType: 'application/json; charset=utf-8',
			    error: function (err) { alert('Could not connect to the registration server. Please try again later.') },
			    success: function (data) {
			      if (data.result === 'success') {
			        // Yeahhhh Success
			        console.log(data.msg)
			        $('<p class="subscribedMC">Subscribed</p>').insertBefore('#referafriendpop');
			        $('#referafriendpop').hide();
			      } else {
			        // Something went wrong, do something to notify the user.
			        console.log(data.msg)
			        $('<p>'+data.msg+'</p>').appendTo('.referpop .mcErrors');
			      }
			    },
			    complete: function(){
			    }
			  });
			};
});


// SEARCH ICON

$('.search-header__submit').on('click', function(event) {
		event.preventDefault();
		$('.prischsearch').toggleClass('is-active');
});
$('.closeSearch').click(function(event) {
		event.preventDefault();
		$('.prischsearch').removeClass('is-active');
});

// REMOVE FIXED SEARCH

$(window).scroll(function(){
  	var scroll = $(window).scrollTop();
	  if (scroll > 300) {
	    $('.prischsearch').removeClass('is-active');
	  }
  });


// REMOVE REFER BAR
var referbar = Cookies.get('hide-referbar');
if (referbar) {
} else {
	$('.referpop').addClass('is-active');
}

$('.referpop button').click(function(event) {
	event.preventDefault();
	Cookies.set('hide-referbar', true,{ expires: 7 });
	$('.referpop').removeClass('is-active');
});


  	// FAQ
var question = $('.question');
  	if (question.length > 0) {
  	var open = $('.questionarea').find('.question');
  	open.click(function(event) {

  	 event.preventDefault();
  	   var $this = $(this),
  	       speed = 300;
  	   if($this.hasClass('active') === true) {
  	       $this.removeClass('active').next('.answer').slideUp(speed);
  	   } else if(open.hasClass('active') === false) {
  	       $this.addClass('active').next('.answer').slideDown(speed);
  	   } else {
  	       open.removeClass('active').next('.answer').slideUp(speed);
  	       $this.addClass('active').next('.answer').delay(speed).slideDown(speed);
  	   }
  	});
}



    $('.site-nav__link').click(function() {
      $(this).toggleClass('is-active')
    });



	  // QUICK VIEW?

	  // $('.p-quick-view').click(function() {
	  // 	  	var productUrl = $(this).data('url');
	  // 	  	var dataSrc = $(this).data('src');
	  // 	    jQuery.getJSON(productUrl + '.js', function(product) {
	  // 	      console.log(product.variants[0].id)
			//   	      var quickviewbox = $('body').find(dataSrc);
	  // 	      		quickviewbox.append('<p><img src="'+product.featured_image+'" alt="" /></p>');
	  // 	      		quickviewbox.append('<p>'+product.title+'</p>');
	  // 	      		quickviewbox.append('<p>'+product.description+'</p>');
	  // 	      		var inputID = quickviewbox.find('.p-quick-view-form input#id');
	  // 	      		inputID.val( product.variants[0].id )

	  // 	    } );
	  // });


// // FIND A ROUTINE

// $('.find-a-routine').click(function(event) {
// 		event.preventDefault();
// 		$(this).next('ul').toggleClass('is-active');
// });



// // FIND A ROUTINE

// $('.find-a-routine-li ul li a').click(function(event) {
// 			event.preventDefault();
// 			$('.find-a-routine').next('ul').removeClass('is-active');
// 			var thisclass= 'routine-'+$(this).attr('class');
// 			console.log(thisclass)
// 			// HIDE ALL
// 			$('.routine_answers').hide();
// 			// SHOW MATCHING
// 			var answer = $('.routine_answers.'+thisclass);
// 			answer.show();
// });


	// ready
});